// src/stone/illustrations/HandQrCodeIllustration.tsx
import { jsx, jsxs } from "react/jsx-runtime";
var HandQrCodeIllustration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  {
    xmlns: "http://www.w3.org/2000/svg",
    width: "1em",
    height: "1em",
    fill: "none",
    viewBox: "0 0 112 119",
    ...props,
    children: [
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          stroke: "#FCFCFC",
          d: "M31.453 69.714H2.379c-.558 0-1.045-.17-1.381-.423C.662 69.04.5 68.73.5 68.428v-30.26c0-.3.16-.61.496-.863.336-.252.823-.423 1.383-.423h29.074c.558 0 1.045.17 1.381.422s.498.562.498.864v30.26c0 .301-.162.611-.498.863s-.823.423-1.381.423Z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M25.605 49.856h-4.436a.6.6 0 0 1-.602-.6v-4.43c0-.333.268-.6.602-.6h4.436c.334 0 .601.267.601.6v4.43c0 .326-.267.6-.601.6M22.552 58.808h-1.477a.197.197 0 0 1-.2-.2v-1.474c0-.113.087-.2.2-.2h1.477c.114 0 .2.087.2.2v1.474c0 .114-.086.2-.2.2M22.552 62.563h-1.477a.197.197 0 0 1-.2-.2v-1.474c0-.114.087-.2.2-.2h1.477c.114 0 .2.086.2.2v1.474c0 .113-.086.2-.2.2M26.314 58.808h-1.477a.197.197 0 0 1-.2-.2v-1.474c0-.113.087-.2.2-.2h1.477c.113 0 .2.087.2.2v1.474c0 .114-.087.2-.2.2M24.436 60.688H22.96a.197.197 0 0 1-.2-.2v-1.474c0-.114.086-.2.2-.2h1.476c.114 0 .2.086.2.2v1.474c0 .107-.093.2-.2.2M12.65 62.564H8.214a.6.6 0 0 1-.601-.6v-4.43c0-.333.267-.6.6-.6h4.437c.334 0 .601.267.601.6v4.43c0 .333-.267.6-.6.6M12.65 49.856H8.214a.6.6 0 0 1-.601-.6v-4.43c0-.333.267-.6.6-.6h4.437c.334 0 .601.267.601.6v4.43c0 .326-.267.6-.6.6M29.754 54.393H4.292a1 1 0 1 1 0-2.002h25.462a1 1 0 1 1 0 2.002"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M17.02 67.1a1 1 0 0 1-1.003-1V40.676a1 1 0 0 1 1.003-1 1 1 0 0 1 1.002 1V66.1A1 1 0 0 1 17.02 67.1"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M28.545 67.107H5.495a2.21 2.21 0 0 1-2.211-2.209v-23.02c0-1.214.989-2.208 2.211-2.208h23.05c1.216 0 2.212.987 2.212 2.208v23.02c0 1.221-.996 2.209-2.212 2.209m-23.05-25.43a.21.21 0 0 0-.207.207v23.021c0 .114.094.207.207.207h23.05a.21.21 0 0 0 .207-.207v-23.02a.21.21 0 0 0-.207-.207z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E09661",
          d: "M36.623 99.925C27.97 89.665 25.2 55.27 32.378 42.633c1.839-3.23 7.825-3.281 10.492 4.423a182 182 0 0 1 3.254 10.405c10.534-20.695 15.038-23.546 19.128-22.929 2.722.4 9.677 4.203 2.677 15.984-.161.267-.332.54-.503.82-.005.017-.03.04-.039.054s.026-.005.035-.005a23 23 0 0 1 2.276-.269c10.592-.804 11.917 6.514 8.818 10.945-1.152 1.644-3.12 3.077-5.063 4.195a41 41 0 0 1-5.615 2.66c.228.094.456.185.676.294 8.488 3.942 13.325 12.52 11.86 21.373-1.93 11.708-10.75 19.12-20.635 19.551-9.69.435-17.268-3.269-23.116-10.21"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m62.901 53.913-.09-.627.39-.124c-.096.242-.199.492-.3.751M65.749 68.43l-.639 1.059-2.206-15.528q.966-.338 1.847-.55l5.265 12.011a35 35 0 0 1-4.267 3.007"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "M65.359 81.58 50.27 84.475a2.11 2.11 0 0 1-2.47-1.676L36.48 23.745a2.11 2.11 0 0 1 1.675-2.47l15.089-2.893a2.11 2.11 0 0 1 2.47 1.676L67.034 79.11a2.11 2.11 0 0 1-1.675 2.47"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m65.355 81.571-15.088 2.894a2.11 2.11 0 0 1-2.47-1.682L40.15 42.898l21.588 8.59 5.293 27.614a2.11 2.11 0 0 1-1.675 2.47"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#00A868",
          d: "m95.253 75.847-36.95 7.085a2.467 2.467 0 0 1-2.888-1.959L44.228 22.62a2.467 2.467 0 0 1 1.958-2.887l36.951-7.084a2.467 2.467 0 0 1 2.887 1.958L97.212 72.96a2.467 2.467 0 0 1-1.959 2.887"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#FCFCFC",
          d: "m91.218 69.278-32.374 6.207-9.402-49.04 32.375-6.206z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E8E9EA",
          d: "M87.91 70.117 58.54 75.748l-9.402-49.04 29.372-5.63z"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m75.866 42.867-3.86.726a.53.53 0 0 1-.622-.425l-.725-3.854a.53.53 0 0 1 .426-.62l3.86-.726a.53.53 0 0 1 .622.424l.724 3.854a.534.534 0 0 1-.425.62M74.673 51.156l-1.285.242a.174.174 0 0 1-.207-.142l-.242-1.283a.174.174 0 0 1 .142-.207l1.285-.241a.174.174 0 0 1 .207.141l.241 1.283a.174.174 0 0 1-.141.207M75.287 54.425l-1.285.242a.174.174 0 0 1-.207-.142l-.241-1.282a.174.174 0 0 1 .142-.207l1.285-.242a.174.174 0 0 1 .207.141l.24 1.283a.174.174 0 0 1-.14.207M77.947 50.54l-1.285.242a.174.174 0 0 1-.207-.141l-.241-1.283a.174.174 0 0 1 .142-.207l1.285-.242a.174.174 0 0 1 .207.142l.24 1.283a.174.174 0 0 1-.14.207M76.621 52.486l-1.285.241a.174.174 0 0 1-.207-.141l-.241-1.283a.174.174 0 0 1 .142-.207l1.284-.242a.174.174 0 0 1 .208.142l.24 1.283a.18.18 0 0 1-.14.207M66.672 56.043l-3.86.726a.53.53 0 0 1-.622-.424l-.725-3.855a.53.53 0 0 1 .425-.62l3.86-.726a.53.53 0 0 1 .622.424l.725 3.854a.53.53 0 0 1-.425.621M64.594 44.986l-3.861.726a.53.53 0 0 1-.621-.425l-.725-3.854a.53.53 0 0 1 .425-.62l3.86-.726a.53.53 0 0 1 .622.424l.725 3.854a.533.533 0 0 1-.425.621M80.219 46.135 58.062 50.3a.886.886 0 1 1-.328-1.741l22.157-4.165a.885.885 0 1 1 .328 1.741"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M71.216 59.277a.885.885 0 0 1-1.036-.707l-4.158-22.122a.886.886 0 0 1 .708-1.035.886.886 0 0 1 1.036.707l4.158 22.122a.885.885 0 0 1-.708 1.035"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "m81.246 57.397-20.059 3.77a1.96 1.96 0 0 1-2.285-1.56l-3.766-20.032a1.96 1.96 0 0 1 1.564-2.283l20.058-3.77a1.96 1.96 0 0 1 2.286 1.56l3.765 20.032a1.96 1.96 0 0 1-1.563 2.283M57.028 39.04a.184.184 0 0 0-.146.214l3.765 20.033a.184.184 0 0 0 .214.146l20.059-3.77a.184.184 0 0 0 .146-.214L77.3 35.415a.184.184 0 0 0-.214-.146zM64.667 21.363a1.335 1.335 0 1 1 .656-2.589 1.335 1.335 0 0 1-.656 2.589"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#E09661",
          d: "M42.204 96.307c-1.24-4.719-7.956-19.213 1.067-27.097 4.55-3.973 9.54-6.491 13.055-7.455 1.901-.395 5.152.683 6.192 3.865.98 3.311-1.103 10.264-6.16 13.833 6.856.163 12.87 6.134 14.047 11.383"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#1D232A",
          d: "M42.203 96.31a.302.302 0 0 0 .332-.441c-1.083-1.924-3.92-9.512-3.511-16.92a14.76 14.76 0 0 1 5.27-10.494 30 30 0 0 1 2.795-2.127.302.302 0 1 0-.328-.51 32 32 0 0 0-2.854 2.173 15.37 15.37 0 0 0-5.489 10.922c-.419 7.552 2.483 15.287 3.587 17.252a.3.3 0 0 0 .198.145M70.33 91.133a.31.31 0 0 0 .33-.132.3.3 0 0 0 .04-.226c-.726-3.234-3.207-6.649-6.476-8.913a.302.302 0 0 0-.335.499c3.151 2.182 5.536 5.459 6.23 8.55a.3.3 0 0 0 .212.222"
        }
      ),
      /* @__PURE__ */ jsx(
        "path",
        {
          fill: "#42EC9A",
          d: "m25.066 29.33 3.661-10.133 10.136-3.655-10.134-3.659-3.655-10.137-3.659 10.133-10.137 3.655 10.133 3.661z"
        }
      )
    ]
  }
);
var HandQrCodeIllustration_default = HandQrCodeIllustration;

export {
  HandQrCodeIllustration,
  HandQrCodeIllustration_default
};
